import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { HandBookFirstLevelData } from '../handbook-first-level/handbook-first-level.component.converter'
import { ConvertedComponentData } from '../../types'
import { CmsConverterService, defaultFSCatalog, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class HandBookThirdLevelConverter extends CmsConverterService<HandBookThirdLevelData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      content: formData?.st_content ?? defaultFSCatalog,
      headline: formData?.st_headline ?? defaultTextInput
    }
  }
}

export const HANDBOOK_THIRD_LEVEL_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, HandBookThirdLevelData>>('HandBookThirdLevelConverter')

export interface HandBookThirdLevelData extends HandBookFirstLevelData, ConvertedComponentData {
}
